const Arrow = () => {
  return (
    <svg
      className='list-options__svg'
      width='17'
      height='19'
      viewBox='0 0 17 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9357 4.58426L1.9679 9.06657C1.1313 9.3799 1.07825 10.5431 1.88285 10.9313L6.35924 13.091C6.56582 13.1907 6.73255 13.3574 6.83227 13.5639L9.03125 18.1189C9.42268 18.9298 10.5976 18.8674 10.901 18.0197L15.2473 5.87689C15.5385 5.06335 14.7448 4.2812 13.9357 4.58426Z'
        fill='white'
      />
    </svg>
  );
};
export default Arrow;
